import React from 'react';

import { Theme } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import AppFormTextField, {
  IFormTextField,
} from '../../../../components/designe/forms/app-form-text-field/FormTextField';

const useStyles = makeStyles<Theme>()((theme) => ({
  root: {
    width: '100%',
    '& .MuiInputBase-root': {
      backgroundColor: `${theme.palette.background.default} !important`,
      height: '56px',
    },
  },
}));

const AuthTextField: React.FC<IFormTextField> = ({
  fullWidth = true,
  className,
  ...props
}) => {
  const theme = useTheme();

  const { classes } = useStyles(theme);
  return (
    <AppFormTextField
      {...props}
      fullWidth={fullWidth}
      classes={{ root: classes.root }}
      className={className}
    />
  );
};

export default AuthTextField;
